import * as React from 'react';
import { Tabs } from 'antd';
import { IconContext } from "react-icons";
import { MdWhatshot, MdTrendingUp } from 'react-icons/md';

import { withHeaderContext, HeaderContext } from '../../context/HeaderContext';

const TabPane = Tabs.TabPane;

interface Props {
  headerContext: HeaderContext;
  renderRefresh: () => any;
}

export class SortTabsC extends React.PureComponent<Props> {
  callback = (key: string) => {
    if (key === "1") {
      this.props.headerContext.updateScoreSort(["DESC"]);
    } else {
      this.props.headerContext.updateDateSort(["DESC"]);
    }
  }
  renderTopSpan = () => (
    <IconContext.Provider value={{ size: "1.2em", style: { verticalAlign: 'middle' } }}>
      <MdWhatshot /> <span style={{ fontSize: 16, fontWeight: 600 }}>Hot</span>
    </IconContext.Provider>
  )
  renderLatestSpan = () => (
    <IconContext.Provider value={{ size: "1.2em", style: { verticalAlign: 'middle' } }}>
      <MdTrendingUp /> <span style={{ fontSize: 16, fontWeight: 600 }}>Latest</span>
    </IconContext.Provider>
  )
  render() {
    return (
      <Tabs
        defaultActiveKey="1"
        onChange={this.callback}
        animated={false}
        style={{ marginTop: 10, marginBottom: 10 }}
        tabBarExtraContent={this.props.renderRefresh()}
      >
        <TabPane tab={this.renderTopSpan()} key="1" />
        <TabPane tab={this.renderLatestSpan()} key="2" />
      </Tabs>
    );
  }
}

export const SortTabsComponent = withHeaderContext(SortTabsC);



// WEBPACK FOOTER //
// ./src/modules/layout/SortTabsComponent.tsx